import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import type { BaseError } from '@utils/types/shared/base.ts';

async function cancelPublishJob(jobId: string): Promise<void> {
  await Axios.post(POST_URL(jobId).cancelPublishJob);
}

export function useCancelPublishJob() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, string>(cancelPublishJob, {
    onSuccess: (_void, jobId) => {
      queryClient.invalidateQueries(QueryKeys.publishJob(jobId));
    },
    useErrorBoundary: false
  });
}
